export default __webpack_public_path__ + "static/mailerlite-hero-img-0cab832296a166e6ef3bb5c08b48659b.png";